import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = ["onClick"];
var _hoisted_2 = {
  key: 0,
  class: "tooltip"
};
export default {
  __name: 'SubTab',
  props: {
    tabs: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    defaultIndex: {
      type: Number,
      default: 1
    }
  },
  emits: ['change'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    var handleChange = function handleChange(item, index) {
      if (!item.exist) return;
      emit('change', item, index);
    };
    return function (_ctx, _cache) {
      var _props$tabs;
      return _openBlock(), _createElementBlock("ul", {
        class: _normalizeClass(['common-sub-tab', !((_props$tabs = props.tabs) !== null && _props$tabs !== void 0 && _props$tabs.length) && 'no-value'])
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tabs, function (item, index) {
        return _openBlock(), _createElementBlock("li", {
          key: item.value,
          class: _normalizeClass(['tab-item', item.value === props.defaultIndex && 'is-active', !item.exist && 'is-disabled']),
          onClick: function onClick($event) {
            return handleChange(item, index);
          }
        }, [_createTextVNode(_toDisplayString(item.name) + " ", 1), !item.exist ? (_openBlock(), _createElementBlock("i", _hoisted_2, "敬请期待")) : _createCommentVNode("", true)], 10, _hoisted_1);
      }), 128))], 2);
    };
  }
};